<template>
<v-container class="mt-8">

    <v-row>
        <!-- Información básica del grupo -->
        <v-col cols="12" class="pb-4">
            <v-card class="mx-auto transparent elevation-0">
                <v-card-text class="pb-0">
                    <div class="mb-0 font-weight-bold text-h5 colorCurso text-center">
                        Mis facturas
                    </div>
                </v-card-text>
            </v-card>
        </v-col>

        <v-col cols="12">
            <v-card class="shadowCard">
                <v-card-title primary-title>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark class="mb-2" @click="abrirDialogo" small rounded>
                        Agregar
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-row justify="end">
                        <v-col cols="12" md="8" lg="5">
                            <v-text-field name="name" label="Buscar" id="id" filled dense hide-details append-icon="mdi-magnify" v-model="search"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-data-table :headers="headers" :items="facturasSolicitadas" class="elevation-0" :search="search" :page.sync="page" @page-count="pageCount = $event" :mobile-breakpoint="100" hide-default-footer dense>
                                <!-- Valores que ocupan botons, chips, iconos, etc -->
                                <template v-slot:item.activo_sn="{ item }">
                                    <v-chip v-if="item.activo_sn == 1" small color="green" dark>Si</v-chip>

                                    <v-chip v-else small color="error" dark>No</v-chip>
                                </template>

                                <template v-slot:item.actions="{ item }">
                                    <v-btn color="primary" x-small @click="editItem(item)" class="mr-2">
                                        <v-icon small>mdi-magnify</v-icon>
                                    </v-btn>

                                </template>

                                <template v-slot:item.pdf="{ item }">
                                    <v-btn v-if="item.pdf" color="blue" dark x-small @click="descargar(item.pdf)" class="mr-2">
                                        <v-icon small>mdi-download</v-icon>
                                    </v-btn>
                                </template>

                                <template v-slot:item.xml="{ item }">
                                    <v-btn v-if="item.xml" color="blue" dark x-small @click="descargar(item.xml)" class="mr-2">
                                        <v-icon small>mdi-download</v-icon>
                                    </v-btn>
                                </template>

                                <template v-slot:item.aceptada="{ item }">
                                    <v-chip v-if="( !item.xml || !item.pdf) && item.aceptada != 2" color="grey" dark small>PENDIENTE</v-chip>
                                    <v-chip v-if="item.xml && item.pdf" color="green" dark small>ACEPTADA</v-chip>
                                    <v-chip v-if="item.aceptada == 2" color="black" dark small>RECHAZADA</v-chip>
                                </template>

                                <template v-slot:item.tiempo_transcurrido="{ item }">
                                    <v-chip v-if="item.tiempo_transcurrido <= 2 || ( item.pdf && item.xml )" color="green" dark small>{{
                      item.tiempo_transcurrido }} días</v-chip>
                                    <v-chip v-if="item.tiempo_transcurrido > 2 && ( !item.pdf || !item.xml )" color="red" dark small>{{
                      item.tiempo_transcurrido }} días</v-chip>
                                </template>

                                <template v-slot:no-data>
                                    <v-btn color="primary" @click="initialize" small>
                                        Actualizar
                                    </v-btn>
                                </template>

                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-pagination circle v-model="page" :length="pageCount" :total-visible="7"></v-pagination>
                </v-card-actions>
            </v-card>
        </v-col>

    </v-row>

    <v-speed-dial top fixed>
        <template v-slot:activator>
            <v-btn color="white" dark fab :to="{name: 'Perfil'}">
                <v-icon color="primary">
                    mdi-keyboard-backspace
                </v-icon>
            </v-btn>
        </template>
    </v-speed-dial>

    <!-- Dialogo de editar o agregar-->
    <v-dialog v-model="dialog" max-width="600px" persistent>
        <v-card>
            <v-card-title>
                <span class="text-subtitle-1">{{ formTitle }}</span>
                <v-spacer></v-spacer>
                <span class="text-subtitle-1">
                    <strong>ID: {{ editedItem.idsolicitar_factura }}</strong>
                </span>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-autocomplete filled dense readonly v-model="editedItem.id_alumno" :items="alumnos" return-object label="Selecciona el alumno" persistent-hint hide-details item-text="alumno" item-value="id_alumno">
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="editedItem.razon_social" label="Razón Social" filled hide-details dense readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="editedItem.rfc" label="RFC" filled hide-details dense readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-autocomplete filled dense v-model="editedItem.regimen_fiscal" :items="regimen" label="Selecciona regimen" hide-details item-text="regimen" item-value="regimen_fiscal" readonly>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="editedItem.direccion" label="Dirección" filled hide-details dense readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-autocomplete filled dense v-model="editedItem.municipio" :items="municipios" label="Selecciona municpio" hide-details item-text="municipio" item-value="idmunicipios" readonly>
                        </v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="6">
                        <v-text-field v-model="editedItem.cp" label="CP" filled hide-details dense readonly>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                        <v-text-field v-model="editedItem.telefono" label="Teléfono" filled hide-details dense readonly>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12">
                        <v-text-field v-model="editedItem.correo" label="Correo" filled hide-details dense readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-autocomplete filled dense v-model="inputGrupo" :items="pagoDetalle" label="Selecciona grupo" hide-details item-text="grupo" item-value="id_grupo" @change="onGrupoChange(null)" :readonly="editedIndex !== -1">
                            <!-- Cómo se muestran los items en el menú --> <template v-slot:item="data">
                                <div>{{ data.item.grupo }}</div>
                            </template> <!-- Cómo se muestra el seleccionado en el input --> <template v-slot:selection="data">
                                <div>{{ data.item.grupo }}</div>
                            </template> </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-autocomplete filled dense v-model="editedItem.uso_cfdi" :items="cfdi" label="Selecciona USO CFDI" hide-details item-text="uso_cfdi" item-value="uso_cfdi" :readonly="editedIndex >= 0"> </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-autocomplete filled dense v-model="editedItem.id_plantel" :items="sucursales" label="Selecciona plantel" hide-details item-text="plantel" item-value="id_plantel" readonly>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="editedItem.subtotal" label="Subtotal" filled hide-details dense type="number" readonly></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="editedItem.total" label="total" filled hide-details dense type="number" readonly></v-text-field>
                    </v-col>
                    <!-- <v-col cols="12" md="6"> <v-select :items="['BanRegio','BBVA','HSBC']" v-model="editedItem.cuenta_escuela" label="Cuenta escuela" filled hide-details readonly ></v-select> </v-col> -->
                    <v-col cols="12" md="6">
                        <v-select :items="formasPago" v-model="editedItem.id_metodo_pago" item-text="forma_pago" item-value="id_forma_pago" label="Tipo de pago" filled hide-details readonly></v-select>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-autocomplete filled dense v-model="editedItem.id_ciclo" :items="ciclos" label="Selecciona ciclo" hide-details item-text="ciclo" item-value="id_ciclo" readonly> </v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea v-model="editedItem.observaciones" label="Notas" filled hide-details :readonly="editedIndex >= 0" :rows="3"></v-textarea>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea v-model="editedItem.motivo_rechazo" label="Motivo del rechazo" filled hide-details :readonly="editedIndex >= 0" :rows="3"></v-textarea>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn color="red" dark small rounded @click="close">
                    Cancelar </v-btn>
                <v-spacer></v-spacer>
                <v-btn v-if="!errorIva" color="primary" dark small rounded @click="save"> Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog> <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
            <v-card-text>
                <v-row justify="space-around">
                    <v-col cols="6">
                        <v-card class="elevation-0" height="100%" style="display: table;">
                            <div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
                                <strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el ciclo? <v-card-actions class="pt-6">
                                    <!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
                                    <v-btn color="error" text class="mr-2" @click="closeDelete()">No, cancelar</v-btn> <!-- Guardar la información -->
                                    <v-btn color="#5C5C5C" dark class="elevation-6" @click="deleteItemConfirm()">Si</v-btn>
                                </v-card-actions>
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="5">
                        <v-img src="@/assets/borrar.png"></v-img>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialogErrorConstancia" max-width="450px">
        <v-card class="py-6 px-4 text-center">

            <!-- Icono de alerta -->
            <v-avatar size="70" class="mx-auto mb-4" color="red lighten-4">
                <v-icon size="40" color="red darken-2">mdi-alert-circle</v-icon>
            </v-avatar>

            <!-- Título -->
            <div class="headline mb-2" style="color: #D32F2F;">Error</div>

            <!-- Mensaje -->
            <div class="subtitle-1 mb-4" style="color: #555;">
                No se encontró una
                <strong style="color: #E53935;">constancia fiscal</strong> registrada.<br>
                Por favor agréguela desde
                <strong style="color: #1976D2;">Perfil → Datos Fiscales</strong>.
            </div>

            <!-- Acciones -->
            <v-card-actions class="justify-center">
                <v-btn color="error" @click="dialogErrorConstancia = false">
                    Cerrar
                </v-btn>
                <v-btn color="primary" dark :to="{ name: 'Perfil' }">
                    Ir a Perfil
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <Loader v-if="cargar" :loader="loader" />

</v-container>
</template>

<script>
// importar librerías
import {
    mapGetters
} from 'vuex'

// Componentes
import Alerta from '@/components/alertas/Alerta.vue'
import Loader from '@/components/alertas/Loader.vue'
import {
    RouterLink
} from 'vue-router'

export default {

    components: {
        Alerta,
        Loader
    },

    data: () => ({
        //Alertas
        respuestaAlerta: false,
        loader: true,
        cargar: false,

        parametros: {
            dialogError: false,
            mensaje: '',
            color: ''
        },

        dialog: false,
        dialogDelete: false,
        dialogErrorConstancia: false,
        errorIva: false,

        editedIndex: -1,

        editedItem: {
            idsolicitar_factura: '',
            id_alumno: '',
            alumno: '',
            rfc: '',
            regimen_fiscal: '',
            regimen: '',
            direccion: '',
            municipio: '',
            cp: '',
            telefono: '',
            correo: '',
            uso_cfdi: '',
            plantel: '',
            subtotal: '',
            total: '',
            cuenta_escuela: '',
            ciclo: '',
            id_usuario: '',
            razon_social: '',
            sucursal: '',
            id_ciclo: '',
            ciclo: '',
            id_metodo_pago: '',
            metodo_pago: '',
            observaciones: '',
            constancia: '',
            url_foto: '',
            id_grupo: '',
            grupo: '',
        },

        defaultItem: {
            idsolicitar_factura: '',
            id_alumno: '',
            alumno: '',
            rfc: '',
            regimen_fiscal: '',
            direccion: '',
            municipio: '',
            cp: '',
            telefono: '',
            correo: '',
            uso_cfdi: '',
            plantel: '',
            subtotal: '',
            total: '',
            cuenta_escuela: '',
            ciclo: '',
            id_usuario: '',
            razon_social: '',
            sucursal: '',
            ciclo: '',
            metodo_pago: '',
            observaciones: '',
            constancia: '',
        },

        // tabla
        search: '',
        page: 1,
        pageCount: 0,
        itemsPerPage: 10,
        facturasSolicitadas: [],
        headers: [{
                text: 'ID',
                value: 'idsolicitar_factura'
            },
            {
                text: 'Alumno',
                value: 'alumno'
            },
            {
                text: 'Subtotal',
                value: 'subtotal'
            },
            {
                text: 'Total',
                value: 'total'
            },
            {
                text: 'Cuenta',
                value: 'cuenta_escuela'
            },
            {
                text: 'Plantel',
                value: 'plantel'
            },
            {
                text: 'Ciclo',
                value: 'ciclo'
            },
            {
                text: 'Aceptada',
                value: 'aceptada'
            },
            {
                text: 'Transcurrido',
                value: 'tiempo_transcurrido'
            },
            {
                text: 'XML',
                value: 'xml'
            },
            {
                text: 'PDF',
                value: 'pdf'
            },
            {
                text: 'Actions',
                value: 'actions',
                sortable: false
            },
        ],

        alumnos: [],
        municipios: [],
        regimen: [],
        cfdi: [],
        ciclos: [],
        sucursales: [],
        formasPago: [],
        pagoDetalle: [],
        inputGrupo: '',
        iderp: '',
        usuarioLMS: {}
    }),

    computed: {
        ...mapGetters('login', ['getGrupo', 'getUsuarioLMS', 'getDatosUsuarioLMS']),
        formTitle() {
            return this.editedIndex === -1 ? 'Agregar datos fiscales' : 'Editar datos fiscales'
        },
    },

    async created() {

        await this.initialize()
        await this.getUsoCFDI()
    },

    methods: {
        async initialize() {

            this.cargar = true
            // id_alumno = iderp
            this.facturasSolicitadas = []
            // TODDO RECUPERAR El USUARIO IDERP
            return this.$http
                .get(`facturas.solicitadas/${ await this.getUsuarioLMS.iderp }`)
                .then(response => {
                    if (response.data) this.facturasSolicitadas = response.data
                    this.cargar = false
                }).catch(error => {
                    this.validarError(error.response.data.message)
                }).finally(() => {
                    this.cargar = false
                })

        },

        async getAlumnoFiscales() {
            if (this.editedIndex === -1) this.cargar = true
            this.alumnos = []
            const iderp = await this.getUsuarioLMS.iderp
            return this.$http.get(`facturas.alumno/${ iderp }`)
                .then(async response => {
                    if (!(response.data && response.data[0])) throw new Error('No se encontro Constancia Fiscal')
                    console.log('datos')
                    this.alumnos = response.data
                    this.editedItem.id_alumno = this.alumnos[0];
                    if (this.editedIndex === -1) this.editedItem = response.data[0]

                    this.municipios = [{
                        idmunicipios: response.data[0].idmunicipios,
                        municipio: response.data[0].municipio
                    }]

                    this.regimen = [{
                        regimen_fiscal: response.data[0].regimen_fiscal,
                        regimen: response.data[0].regimen
                    }]

                    this.editedItem.municipio = response.data[0].idmunicipios
                    this.editedItem.regimen_fiscal = response.data[0].regimen_fiscal
                    this.editedItem.regimen = response.data[0].regimen

                    if (!this.editedItem.correo) {
                        //console.log('No tengo correo, usar ddel mixin')
                        this.editedItem.correo = this.getDatosUsuarioLMS.email
                    }

                    if (!this.editedItem.telefono) {
                        //console.log('No tengo celular usar del mixin')
                        this.editedItem.telefono = await this.getUsuarioLMS.movil;
                    }

                    if (!this.pagoDetalle.length) await this.getPagoDetalleAlumno()
                }).catch(error => {
                    this.validarError(error.response.data.message)
                })
        },

        getUsoCFDI() {
            this.cargar = true
            this.cfdi = []
            return this.$http.get('uso.cfdi').then(response => {
                this.cfdi = response.data
                this.cargar = false
            }).catch(error => {
                this.validarError(error.response.data.message)
            }).finally(() => {
                this.cargar = false
            })
        },

        async getPagoDetalleAlumno() {
            this.pagoDetalle = []
            console.log('pagos: ' + await this.getUsuarioLMS.iderp )
            return this.$http.get(`pagos.detalle.alumno/${ await this.getUsuarioLMS.iderp }`)
                .then(response => {
                    this.pagoDetalle = response.data
                }).catch(error => {
                    this.validarError(error.response.data.message)
                }).finally(() => {
                    if (this.editedIndex === -1) this.cargar = false
                })
        },

        onGrupoChange(pagoDetalle) {
          console.log('grupo seleccionado')
          console.log( pagoDetalle )
          if (!pagoDetalle) pagoDetalle = this.pagoDetalle.find(p => p.id_grupo === this.inputGrupo)
          else this.inputGrupo = pagoDetalle.id_grupo
          console.log( 'detalle Pago' )
          console.log( pagoDetalle )

            this.sucursales = [{
                plantel: pagoDetalle.plantel,
                id_plantel: pagoDetalle.id_plantel
            }]

            this.ciclos = [{
                id_ciclo: pagoDetalle.id_ciclo,
                ciclo: pagoDetalle.ciclo
            }]

            this.formasPago = [{
                id_forma_pago: pagoDetalle.id_forma_pago,
                forma_pago: pagoDetalle.forma_pago
            }]

            this.editedItem.id_plantel = pagoDetalle.id_plantel
            this.editedItem.plantel = pagoDetalle.plantel
            this.editedItem.id_ciclo = pagoDetalle.id_ciclo
            this.editedItem.ciclo = pagoDetalle.ciclo
            this.editedItem.id_metodo_pago = pagoDetalle.id_forma_pago
            this.editedItem.metodo_pago = pagoDetalle.forma_pago

            this.editedItem.subtotal = pagoDetalle.subtotal
            this.editedItem.total = pagoDetalle.pagado
            this.editedItem.url_foto = pagoDetalle.url_foto

            this.editedItem.id_grupo = pagoDetalle.id_grupo
            this.editedItem.grupo = pagoDetalle.grupo

            if(!pagoDetalle.iva) {
              console.log('error iva')
              this.errorIva = true
              // TODO No puedes facturar por que no tiene iva
              return this.validarErrorDirecto('El grupo no cuenta con un iva.')
              //this.editedItem.subtotal = pagoDetalle.pagado / 1.16
            } else {
              console.log('sin error iva')
              this.errorIva = false

              this.editedItem.subtotal = pagoDetalle.pagado / 1.16
            }

        },

        async editItem(item) {

            this.editedIndex = this.facturasSolicitadas.indexOf(item)
            this.editedItem = Object.assign({}, item)

            await this.getAlumnoFiscales()

            const pagoDetalle = this.pagoDetalle
                .find(p => p.id_ciclo.toString() === this.editedItem.ciclo)

            console.log('desde editar')
            this.onGrupoChange(pagoDetalle)
            this.dialog = true
        },

        deleteItem(item) {
            this.editedIndex = this.facturasSolicitadas.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },

        async deleteItemConfirm() {
            this.cargar = true
            // Lo mandapos por el EP
            this.editedItem['id_usuario'] = await this.getUsuarioLMS.iderp
            this.$http.put('factura.eliminar/' + this.editedItem.idsolicitar_factura).then(response => {
                this.cargar = true
                this.closeDelete()
                this.initialize()
            }).catch(error => {
                this.validarError(error.response.data.message)
            }).finally(() => {
                this.cargar = false
            })
        },

        close() {
            this.dialog = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        closeDelete() {
            this.dialogDelete = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        async abrirDialogo() {
            console.log('abrir modal')
            await this.getAlumnoFiscales()
                .then(() => {
                    console.log('open')
                    this.dialog = true
                })
                .catch(res => {
                    console.log('error')
                    this.dialogErrorConstancia = true
                    this.cargar = false
                    this.dialog = false

                })
        },

        async save() {
            this.editedItem.alumno = this.editedItem.id_alumno.alumno
            // Cargamos al usuario que hizo el cambio
            this.editedItem['id_usuario'] = 3345
            this.editedItem['id_alumno'] = await this.getUsuarioLMS.iderp
            this.editedItem['alumno'] = await this.getUsuarioLMS.nombre_completo
            this.editedItem['cuenta_escuela'] = ""

            this.cargar = true

            if (this.editedIndex > -1) {
                // Lo mandapos por el EP
                this.$http.put('datos.fiscales.update/' + this.editedItem.id_forma_pago, this.editedItem).then(response => {
                    this.validarSuccess(response.data.message)
                    this.initialize()
                    this.close()
                }).catch(error => {
                    this.validarError(error.response.data.message)
                }).finally(() => {
                    this.cargar = false
                })

            } else {
                // Lo mandapos por el EP
                console.log( this.editedItem )
                this.$http.post('solicitar.factura', this.editedItem).then(response => {
                    this.initialize()
                    this.close()
                    this.cargar = false
                }).catch(error => {
                    this.validarError(error.response.data.message)
                }).finally(() => {
                    this.cargar = false
                })
            }
        },

        descargar(archivo) {
            window.open('https://escuelakpi.club/kpi/facturas/' + archivo)
        },

        validarSuccess(mensaje) {
            this.cargar = false
            this.parametros.mensaje = mensaje
            this.parametros.dialogError = true
            this.parametros.color = 'success'
            this.respuestaAlerta = true
        },

        validarError(value) {
            this.cargar = false
            if (value.status == 400 || value.status == 500) {
                this.parametros.mensaje = value.body.message
                this.parametros.dialogError = true
                this.parametros.color = '#FF2C2C'
                this.respuestaAlerta = true
            }
        },

        validarErrorDirecto(mensaje) {
            this.cargar = false
            this.parametros.mensaje = mensaje
            this.parametros.dialogError = true
            this.parametros.color = '#FF2C2C'
            this.respuestaAlerta = true
        },

        async descargarCopia(url) {
            window.open(url);
        },
    },

}
</script>

<style scoped>
.cardShow {
    border-radius: 15px !important;
    box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.2) !important;
}

.colorCurso {
    color: #006093;
}
</style>
